import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { CREDIT, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author Burak Ak
 */
const CreditTransactionList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'transactionOrderID',
				filterType: FilterType.string,
				width: 100,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 140,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'shipmentID',
				accessor: 'shipmentID',
				filterType: FilterType.string,
				width: 140,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.multiSelection,
				width: 100,
				show: false
			},
			{
				Header: 'pickupLocation',
				accessor: 'pickupLocation',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PICKUP_LOCATION,
				width: 100,
				show: false
			},
			{
				Header: 'brandName',
				accessor: 'brandName',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				width: 150,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.multiSelection,
				width: 250,
				translate: true
			},
			{
				Header: 'weightUpdate',
				accessor: 'weightUpdateInformation',
				renderCell: ListComponents.WEIGHT_UPDATE_INFORMATION
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.multiSelection,
				width: 130
			},
			{
				Header: 'amount',
				accessor: 'amount',
				filterType: FilterType.float,
				width: 120,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY_COLORED
			},
			{
				Header: 'paidPrice',
				accessor: 'paidPrice',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 80
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				width: 110,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY_BOLD
			},
			{
				Header: 'promoCodeTitle',
				accessor: 'promoCode',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'promoCodeAmount',
				accessor: 'promoCodeAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 80,
				show: false
			},
			{
				Header: 'paymentType',
				accessor: 'paymentType',
				filterType: FilterType.multiSelection,
				width: 110,
				show: false
			},
			{
				Header: 'invoiceLink',
				accessor: 'invoiceLink',
				width: 110,
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_INVOICE,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS,
				renderCell: ListComponents.STATUS,
				statusPrefix: 'creditTransaction.',
				filterPrefix: 'status.creditTransaction.',
				width: 130,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.CREDIT_TRANSACTIONS}
				columns={columns}
				fetchUrl={CREDIT.GET_CREDIT_TRANSACTION_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="creditTransactions"
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default CreditTransactionList;
